import AssetUpload from 'components/AssetUpload';
import { AuditOutlined } from '@ant-design/icons';
import { Card, Form, Input, Select, Typography } from 'antd';
import { CreateLayout } from '../../../components/layout/layout/CreateLayout';
import { ICertifiers } from 'interfaces/certifiers';
import { ISignatures } from 'interfaces/signatures';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { useForm, useSelect } from '@refinedev/antd';
import {
  CERTIFIER_SIGNATURE_ACCEPT,
  validateCertifierSignatureFile
} from './signature-upload';

export const SignaturesCreate = () => {
  const { selectProps } = useSelect<ICertifiers>({
    resource: 'certifiers',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    liveMode: 'manual',

    pagination: {
      mode: 'server'
    }
  });
  const { formProps, saveButtonProps } = useForm<ISignatures>({
    successNotification: () => ({
      type: 'success',
      description: 'Sucesso!',
      message: 'Assinatura criada com sucesso!'
    }),
    errorNotification: () => ({
      type: 'error',
      description: 'Error!',
      message: 'Não foi possível criar a assinatura!'
    })
  });
  return (
    <CreateLayout saveButtonProps={saveButtonProps}>
      <PageHeader title="Criar Assinatura" icon={AuditOutlined} />
      <Card>
        <Form {...formProps} layout="vertical">
          <Typography.Title level={5} style={{ margin: '24px 0' }}>
            Instituição
          </Typography.Title>
          <Form.Item
            label="Nome da instituição"
            name="certifier_id"
            rules={[
              {
                required: true,
                message: 'Nome da instituição obrigatório'
              }
            ]}
          >
            <Select {...selectProps} allowClear style={{ minWidth: 100 }} />
          </Form.Item>
          <Typography.Title level={5} style={{ margin: '24px 0' }}>
            Assinatura
          </Typography.Title>
          <Form.Item
            label="Título"
            name="title"
            rules={[
              {
                required: true,
                message: 'Título obrigatório'
              }
            ]}
          >
            <Input className="max-w-[200px]" />
          </Form.Item>
          <Form.Item
            label="Matrícula"
            name="registration"
            rules={[
              {
                required: true,
                message: 'Matrícula obrigatória'
              }
            ]}
          >
            <Input className="max-w-[200px]" />
          </Form.Item>
          <Form.Item
            label="Nome para impressão"
            name="name"
            rules={[
              {
                required: true,
                message: 'Nome obrigatório'
              }
            ]}
          >
            <Input className="max-w-[500px]" />
          </Form.Item>

          <Form.Item
            label="Assinatura digital"
            name="signature"
            rules={[
              {
                required: true,
                message: 'Assinatura digital obrigatória'
              }
            ]}
          >
            <AssetUpload
              accept={CERTIFIER_SIGNATURE_ACCEPT}
              type="certifier_signature"
              onValidate={validateCertifierSignatureFile}
            />
          </Form.Item>

          <Form.Item
            label="ATO/Portaria"
            name="decree"
            rules={[
              {
                required: true,
                message: 'ATO/Portaria obrigatório'
              }
            ]}
          >
            <Input className="max-w-[200px]" />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
